// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'video-solid';

export const Component = () => (
  <g fill='currentColor' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m14.337 11.809 1.832.915a.532.532 0 0 0 .768-.475V6.53a.53.53 0 0 0-.768-.475l-1.832.915a1.062 1.062 0 0 0-.587.95v2.937a1.062 1.062 0 0 0 .587.951z' />
    <rect width='10.5' height='8.5' x='1' y='5' rx='1.5' />
  </g>
);

export const viewBox = '0 0 18 18';
